import * as React from 'react';

interface DiffPriceProps {
  priceAsString?: string;
}

export function DiffPrice({ priceAsString }: DiffPriceProps) {
  const getTextColor = (price: string) => {
    if (price.toLowerCase().includes('add')) {
      return 'text-blue-500';
    }
    if (price.toLowerCase().includes('subtract')) {
      return 'text-green-800';
    }
    return '';
  };

  if (priceAsString) {
    return (
      <div className={getTextColor(priceAsString)}>
        {priceAsString}
      </div>
    );
  }
  return null;
}
